/**
 * Composable for managing objective assignments
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { fetchAllObjectives, syncObjectiveAssignments } from "../../api/objectives";
export function useObjectiveAssignment() {
    const allObjectives = ref([]);
    const isLoading = ref(false);
    const error = ref(null);
    /**
     * Load all available objectives from API
     */
    const loadAllObjectives = (table, period) => __awaiter(this, void 0, void 0, function* () {
        isLoading.value = true;
        error.value = null;
        try {
            allObjectives.value = yield fetchAllObjectives(table, period);
        }
        catch (err) {
            error.value = err;
            console.error("Error loading all objectives:", err);
            throw err;
        }
        finally {
            isLoading.value = false;
        }
    });
    /**
     * Sync objective assignments
     */
    const syncAssignments = (objectiveIds, table) => __awaiter(this, void 0, void 0, function* () {
        isLoading.value = true;
        error.value = null;
        try {
            yield syncObjectiveAssignments(objectiveIds, table);
        }
        catch (err) {
            error.value = err;
            console.error("Error syncing objective assignments:", err);
            throw err;
        }
        finally {
            isLoading.value = false;
        }
    });
    /**
     * Get assigned objective IDs from current objectives
     */
    const getAssignedIds = (assignedObjectives) => {
        return assignedObjectives.map((obj) => obj.id);
    };
    return {
        allObjectives,
        isLoading,
        error,
        loadAllObjectives,
        syncAssignments,
        getAssignedIds,
    };
}
